import * as React from 'react';
const { useState, useMemo, useCallback } = React;

import Button, { ButtonProps } from '../button';
import {
	ConfirmLayout,
	LabelLayout,
} from './styled';


type ConfirmButtonProps = {
	confirmLabel?: React.ReactNode;
} & ButtonProps;

const ConfirmButton: React.SFC<ConfirmButtonProps> = (props) => {
	const {
		confirmLabel,
		onClick,
		children,
		...rest
	} = props;
	const [showConfirm, setShowConfirm] = useState<boolean>(false);
	const scope = useMemo(() => ({ isMouseEntered: false, timeout: null }), []);

	const handleClick = useCallback((e: React.SyntheticEvent<HTMLButtonElement, Event>) => {
		if (Boolean(confirmLabel)) {
			if (!showConfirm) {
				setShowConfirm(true);
			} else {
				setShowConfirm(false);
				onClick(e);
			}
		} else {
			onClick(e);
		}
	}, [confirmLabel, showConfirm]);

	const handleMouseEnter = useCallback(() => scope.isMouseEntered = true, []);

	const handleMouseLeave = useCallback(() => {
		scope.isMouseEntered = false;

		if (scope.timeout) {
			clearTimeout(scope.timeout);
		}

		scope.timeout = setTimeout(() => {
			if (!scope.isMouseEntered && showConfirm) {
				setShowConfirm(false);
				clearTimeout(scope.timeout);
			}
		}, 1000);
	}, [showConfirm]);

	return (
		<Button
			{...rest}
			style={{ minWidth: 70 }}
			onClick={handleClick}
			onMouseEnter={handleMouseEnter}
			onMouseLeave={handleMouseLeave}>
			{
				showConfirm
					? <ConfirmLayout>{confirmLabel}</ConfirmLayout>
					: <LabelLayout>{children}</LabelLayout>
			}
		</Button>
	);
}

ConfirmButton.displayName = 'ConfirmButton';
ConfirmButton.defaultProps = {
	confirmLabel: 'OK'
};

export default ConfirmButton;
